import {Pipe, PipeTransform} from "@angular/core";


@Pipe({name: 'asistenciaCodigo', standalone: false,})
export class AsistenciaCodigoPipe implements PipeTransform {
    transform(objetos: any[], codigo: string[]) {
        return objetos.find(obj => {return obj.codigo == codigo});
    }
}